import React from "react";
import {
  Stack,
  Flex,
  Text,
  VStack,
  Heading,
  Box,
  SimpleGrid,
  Img,
} from "@chakra-ui/react";
let Logo = require("../imgs/home.jpeg");
let Bread = require("../imgs/showcase/49.jpg");
let Ymmy = require("../imgs/showcase/48.jpg");
let Cake = require("../imgs/showcase/39.jpg");

const home = () => {
  return (
    <div>
      {Hero()}
      <Heading textAlign={"center"} mt={"2rem"} mb={"2rem"}>
        What do we sell?
      </Heading>
      {sellProduct()}
    </div>
  );
};

const Hero = () => {
  return (
    <Flex
      w={"full"}
      h={"50vh"}
      backgroundImage={Logo}
      backgroundSize={"cover"}
      backgroundPosition={"center center"}
    >
      <VStack
        w={"full"}
        justify={"center"}
        px={{ base: 4, md: 8 }}
        bgGradient={"linear(to-r, blackAlpha.600, transparent)"}
      >
        <Stack maxW={"2xl"} align={"flex-start"} spacing={6}>
          <Text
            color={"white"}
            fontWeight={700}
            lineHeight={1.2}
            fontSize={{ base: "3xl", md: "4xl" }}
          >
            HOME MADE BAKERY
          </Text>
          <Text
            color={"white"}
            fontWeight={300}
            lineHeight={1.2}
            fontSize={{ base: "md", md: "2md" }}
          >
            Each of our cakes is hand-decorated by our expert bakers and made
            with a selection of cake and buttercream flavours!
          </Text>
        </Stack>
      </VStack>
    </Flex>
  );
};

const sellProduct = () => {
  return (
    <Box px={20} py={2}>
      <SimpleGrid columns={{ base: 1, md: 5 }} spacing={15}>
        <Box>
          <Img src={Bread}></Img>
        </Box>
        <Box/>
        <Box>
          <Img src={Ymmy}></Img>
        </Box>
        <Box/>
        <Box>
          <Img src={Cake}></Img>
        </Box>
      </SimpleGrid>
      <Text  py={5} fontSize='xl' textAlign="center">We are selling all kind of breads, cakes and desserts. We also do wedding and birthday cakes.</Text>
    </Box>
  );
};

export default home;
